<app-navigation
  class="pc-sidebar"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'mob-open': navCollapsedMob
  }"
  (NavCollapse)="this.navCollapsed = !this.navCollapsed"
/>
<app-nav-bar (NavCollapsedMob)="navMobClick()" (NavCollapse)="this.navCollapsed = !this.navCollapsed" (SettingsSidebarToggle)="toggleSettingsSidebar()" (RoleSelectorToggle)="toggleRoleSelector()" />
<div class="pc-container">
  <div class="coded-wrapper">
    <div class="coded-content">
      <div class="coded-inner-content">
        <!-- <app-breadcrumb /> -->
        <div class="main-body">
          <div class="page-wrapper" [ngClass]="'responsive-' + currentView">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-menu-overlay" (click)="closeMenu()" (keydown)="handleKeyDown($event)" tabindex="0"></div>
</div>
<footer class="pc-footer">
  <div class="footer-wrapper container-fluid">
    <div class="row">
      <div class="col-4 my-1">
        <p class="m-0">
          Copyright &copy;
          <a href="#">Spikyarc</a>
        </p>
      </div>
      <div class="col-4  d-md-block" *ngIf="showResponsiveControls && isPreviewMode()">
        <app-responsive-controls 
          [currentView]="currentView" 
          (viewChange)="onViewChange($event)">
        </app-responsive-controls>
      </div>
      <div class="col-4 responsive">
        <h6>Version</h6>
      </div>
      <!-- <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://codedthemes.com/" [routerLink]="['/dashboard']">Dashboard</a></li>
          <li class="list-inline-item">
            <a href="https://codedthemes.com/privacy-policy/">Privacy Policy</a>
          </li>
          <li class="list-inline-item"><a href="https://codedthemes.support-hub.io/">Contact us</a></li>
        </ul>
      </div> -->
    </div>
  </div>
</footer>
<app-configuration />
<app-settings-sidebar [isOpen]="settingsSidebarOpen" (closeSidebar)="closeSettingsSidebar()" />
<app-role-selector [isOpen]="roleSelectorOpen" (closePopup)="closeRoleSelector()" (roleSelected)="onRoleSelected($event)" />
